<script lang="ts">
    export let value: string;
    export let label: string = 'Link';

    let copied = false;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    async function copy() {
        try {
            await navigator.clipboard.writeText(value);
            copied = true;
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => (copied = false), 2000);
        } catch {
            copied = false;
        }
    }
</script>

<div class="copyable">
    {#if label}
        <label class="lbl">{label}</label>
    {/if}
    <div class="row">
        <input type="text" readonly value={value} on:focus={(e) => e.currentTarget.select()} />
        <button type="button" on:click={copy} aria-label="Copy">
            {copied ? 'Copied!' : 'Copy'}
        </button>
    </div>
</div>

<style>
    .copyable { width: 100%; }
    .lbl {
        display: block;
        font-size: .75rem;
        color: #6b7280;
        margin-bottom: 4px;
        text-transform: uppercase;
        letter-spacing: .05em;
        font-weight: 600;
    }
    .row { display: flex; gap: 6px; }
    input {
        flex: 1;
        padding: 8px 10px;
        font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
        font-size: .8rem;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        background: #f9fafb;
        min-width: 0;
    }
    button {
        padding: 8px 14px;
        border: 1px solid #1d4ed8;
        background: #1d4ed8;
        color: white;
        border-radius: 6px;
        font-size: .85rem;
        font-weight: 600;
        cursor: pointer;
        flex-shrink: 0;
    }
    button:hover { background: #1e40af; }
</style>
